import { render, staticRenderFns } from "./loanList.vue?vue&type=template&id=2f99f1d2&scoped=true&"
import script from "./loanList.vue?vue&type=script&lang=js&"
export * from "./loanList.vue?vue&type=script&lang=js&"
import style0 from "./loanList.vue?vue&type=style&index=0&id=2f99f1d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f99f1d2",
  null
  
)

export default component.exports